<template>
  <header class="page-headline">
    <div class="row">
      <div class="col">
        <h2 :is="tag" class="page-title" :class="[{ 'has-bar': bar }, titleClass]">{{ title }}</h2>
      </div>

      <div v-if="hasRightSlot" class="col-auto">
        <slot name="right-actions"></slot>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeadline',

  props: {
    tag: {
      type: String,
      default: 'h2',
      validator(value) {
        return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value);
      },
    },

    title: {
      type: String,
      required: true,
    },

    titleClass: {
      type: [String, Array, Object],
      default: null,
    },

    bar: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    hasRightSlot() {
      return this.$slots['right-actions'];
    },
  },
};
</script>
